import { Component, OnInit, ChangeDetectionStrategy, ViewChild, Input, OnDestroy, Sanitizer } from '@angular/core';
import { AsamcoUserService } from '@asamco/base';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { LinkInformation } from '../../interfaces/linkinformation.interface';
import { MarketPlaceItem } from '../../interfaces/market-place-item.interface';
import { LinkDescriptionService } from '../../services/link-description.service';
import { LinkEditInfoModalComponent } from '../link-edit-info-modal/link-edit-info-modal.component';
import { NgIf } from '@angular/common';
import { DomSanitizer } from '@angular/platform-browser';
import { SanitizePipe } from '../../pipes/santizehtml.pipe';
import { UnescapePipe } from '../../pipes/html_unescape.pipe';

@Component({
	selector: 'al-link-edit-pricing',
	templateUrl: './link-edit-pricing.component.html',
	styleUrls: ['./link-edit-pricing.component.scss'],
	standalone: true,
	imports: [NgIf, SanitizePipe, UnescapePipe],
})
export class LinkEditPricingComponent implements OnInit, OnDestroy {
	@ViewChild(LinkEditInfoModalComponent)
	editInfoModal: LinkEditInfoModalComponent;

	@Input()
	linkInfo: LinkInformation;

	private destroy$ = new Subject<void>();
	public admin: boolean;

	constructor(private linkDescriptionService: LinkDescriptionService, private asamcoUserService: AsamcoUserService, public sanitizer: DomSanitizer) { }

	ngOnInit(): void {
		this.asamcoUserService.isAdmin().then(result => (this.admin = result));
	}

	ngOnDestroy(): void {
		this.destroy$.next();
		this.destroy$.complete();
	}

	openModal(): void {
		if (this.admin === false) return;
		else {
			this.editInfoModal
				.show('pricing information', this.linkInfo.pricingInformation)
				.pipe(takeUntil(this.destroy$))
				.subscribe(result => {
					this.linkInfo.pricingInformation = result;
					this.linkDescriptionService.setPricingInformation(this.linkInfo.id, result).pipe(takeUntil(this.destroy$)).subscribe({ error: console.error });
				});
		}
	}
}
